import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/Layout';
import Header from '../components/Header';
import What from '../components/What';
import FilmGrid from '../components/FilmGrid';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const IndexPage = ({ data: { datoCmsHomePage, videos } }) => {
  const {
    seoMetaTags,
    headerVideo,
    companyName,
    companyActivity,
    description,
    parallaxImage,
    address,
    zipcode,
    city,
    phone,
    email,
    facebook,
    twitter,
    linkedin,
    clients,
  } = datoCmsHomePage;
  return (
    <Layout seo={seoMetaTags}>
      <Header video={headerVideo} {...{ companyName, companyActivity }} />
      <What text={description} />
      <FilmGrid videos={videos.edges} />
      <Contact
        bg={parallaxImage}
        {...{
          companyName,
          companyActivity,
          address,
          zipcode,
          city,
          phone,
          email,
          facebook,
          twitter,
          linkedin,
        }}
      />
      <Footer clients={clients} />
    </Layout>
  );
};

export default IndexPage;

export const query = graphql`
  query {
    datoCmsHomePage {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      headerVideo {
        url
      }
      headerFallbackImage {
        fluid(maxWidth: 1600, imgixParams: { fm: "jpg", auto: "compress" }) {
          ...GatsbyDatoCmsFluid
        }
      }
      description
      companyName
      companyActivity
      address
      zipcode
      city
      phone
      email
      facebook
      twitter
      linkedin
      parallaxImage {
        fluid(maxWidth: 1600, imgixParams: { fm: "jpg", auto: "compress" }) {
          ...GatsbyDatoCmsFluid
        }
      }
      clients {
        ... on DatoCmsClient {
          logo {
            url
          }
          url
        }
      }
    }
    videos: allDatoCmsVideo(
      filter: { shown: { eq: true } }
      sort: { fields: position, order: ASC }
    ) {
      edges {
        node {
          originalId
          client
          category
          video {
            url
            thumbnailUrl
          }
        }
      }
    }
  }
`;
